import type { ComponentProps, ReactNode } from "react";
import { Link } from "react-router-dom";

import styles from "./styles.module.css";

type Variant = "primary" | "secondary" | "ghost";

interface BaseProps {
  variant?: Variant;
  className?: string;
  children: ReactNode;
}

type ButtonAsLink = BaseProps & { to: string } & Omit<ComponentProps<typeof Link>, "to" | "className">;
type ButtonAsButton = BaseProps & { to?: undefined } & Omit<ComponentProps<"button">, "className">;

export function Button(props: ButtonAsLink | ButtonAsButton) {
  const { variant = "primary", className, children } = props;
  const cls = `${styles.btn} ${styles[variant]} ${className ?? ""}`;

  if ("to" in props && props.to !== undefined) {
    const { to, variant: _v, className: _c, children: _ch, ...rest } = props;
    return (
      <Link to={to} className={cls} {...rest}>
        {children}
      </Link>
    );
  }

  const { variant: _v, className: _c, children: _ch, to: _to, ...rest } = props as ButtonAsButton;
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}

export default Button;
